import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { useSelector } from "react-redux";

import hexagon from "../../../assets/images/hexagon.svg";

import { parseMissionsData } from "../../../utils/missionUtils";

import "./ConfirmationDialog.scss"; // Import the SCSS file

const ConfirmationDialog = ({ open, onClose, handleConfirmation }) => {
  const { user } = useSelector((state) => state.createUser);

  const missionsData = parseMissionsData(user.accomplishmentsManifest);

  // --- Dynamic completed/incomplete logic start ---

  // List of { index: mission#, isCompleted: true/false }
  const completedMissions = missionsData
    .map((mission, idx) => ({
      index: idx + 1,
      title: mission.title,
      isCompleted: mission.completed.every(Boolean), // all levels completed
    }))
    .filter((m) => m.isCompleted);

  const allMissionNumbers = missionsData.map((_, idx) => idx + 1);
  const completedNumbers = completedMissions.map((m) => m.index);
  const incompleteNumbers = allMissionNumbers.filter(
    (n) => !completedNumbers.includes(n)
  );

  let completedPart = "";
  if (completedNumbers.length === 0) {
    completedPart = "You haven't completed any missions yet.";
  } else if (completedNumbers.length === 1) {
    completedPart = `You have completed mission ${completedNumbers[0]} only.`;
  } else {
    completedPart = `You have completed missions ${completedNumbers.join(
      " and "
    )} only.`;
  }
  const incompletePart = incompleteNumbers.length
    ? `You still have mission${
        incompleteNumbers.length > 1 ? "s" : ""
      } ${incompleteNumbers.join(", ")} to complete.`
    : "";

  // --- Dynamic completed/incomplete logic end ---

  return (
    <Dialog
      open={open}
      aria-labelledby="investigation-modal-title"
      className="confirmation-notification"
    >
      {/* Dialog Title */}
      <DialogTitle
        id="investigation-modal-title"
        className="confirmation-dialog__title"
      >
        <img src={hexagon} width={54} height={54} alt="img" />
        <p className="confirmation-dialog__heading">Are you sure?</p>
      </DialogTitle>

      {/* Dialog Content */}
      <DialogContent className="confirmation-dialog__content">
        <p className="confirmation-dialog__message">
          Investigator <span className="userId">{user?.systemName}</span>,{" "}
          {completedPart} {incompletePart}
          {incompleteNumbers.length ? " Are you sure you want to stop?" : ""}
        </p>
      </DialogContent>

      {/* Dialog Actions with Buttons */}
      <DialogActions className="confirmation-dialog__actions">
        <Button
          onClick={handleConfirmation}
          className="confirmation-dialog__button confirmation-dialog__button--stop"
        >
          100% I want to stop
        </Button>
        <Button
          onClick={onClose}
          className="confirmation-dialog__button confirmation-dialog__button--continue"
        >
          Ok, I will continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
